import styled, { css } from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`

export const Panel = styled.div<{ $width?: string }>`
  background-color: #fff;
  border-radius: 0.6rem;
  width: ${(props) => props.$width || '32rem'};
  max-width: 92vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Inter', sans-serif;
`

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid #ebebeb;

  h3 {
    font-size: 0.95rem;
    font-weight: 700;
    margin: 0;
  }
`

export const CloseButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  color: #696969;
  display: flex;
  align-items: center;
`

export const PanelBody = styled.div`
  padding: 1.2rem;
  overflow-y: auto;
  flex: 1;
`

export const PanelFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 1rem 1.2rem;
  border-top: 1px solid #ebebeb;
`

export const FormRow = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-bottom: 0.8rem;

  > div {
    flex: 1;
  }
`

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 0.35rem;
`

// Padrão global de campos (ver globalStyle.ts): pílula de 20px, altura 38px e
// fundo #EBEBEB. Os seletores globais só alcançam inputs com `type` declarado,
// então os valores são repetidos aqui para que os campos sem `type` (texto
// simples) fiquem idênticos aos demais dentro do mesmo formulário.
const fieldBase = css`
  width: 100%;
  height: 38px;
  padding: 8px 16px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 20px;
  background-color: #ebebeb;
  border: 1px solid transparent;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover:not(:disabled) {
    border-color: #cbd5e0;
  }

  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &:disabled {
    background-color: #d3d3d3;
    cursor: not-allowed;
  }
`

export const FieldInput = styled.input`
  ${fieldBase}
`

export const FieldSelect = styled.select`
  ${fieldBase}
  padding-right: 32px;
  cursor: pointer;
`

export const PrimaryButton = styled.button`
  border: none;
  border-radius: 1.6rem;
  padding: 0.5rem 1.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  background-color: #0090d3;
  color: #fff;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const SecondaryButton = styled.button`
  border: 1px solid #dcdcdc;
  border-radius: 1.6rem;
  padding: 0.5rem 1.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  background-color: #fff;
  color: #696969;
`

export const ErrorText = styled.div`
  color: #d32f2f;
  font-size: 0.72rem;
  margin-top: 0.4rem;
`

export const MiniTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.72rem;

  th {
    text-align: left;
    color: #696969;
    font-weight: 400;
    padding: 0.4rem 0.5rem;
    border-bottom: 1px solid #ebebeb;
  }

  td {
    padding: 0.4rem 0.5rem;
    border-bottom: 1px solid #f4f4f4;
  }

  input {
    width: 5rem;
    height: 1.7rem;
    border: 1px solid #dcdcdc;
    border-radius: 0.3rem;
    padding: 0 0.4rem;
    font-size: 0.72rem;
  }
`

export const TotalRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.8rem 0.5rem 0;
  font-size: 0.85rem;

  strong {
    color: #0090d3;
  }
`
